import updateTree from './updateTree'

export default function isLocked(state = {}, action) {
  switch (action.type) {
    case 'SET_IS_LOCKED':
      return updateTree(state, 'isLocked', () => action.isLocked)

    default:
      return {
        isLocked: false,
        ...state,
      }
  }
}
